import type * as Blockly from 'blockly/core';
import { registerSetupCode, resolveDigitalPin, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

export function register(gen: any): void {
    gen.forBlock['vibration_motor'] = function (block: Blockly.Block): string {
        const pin = resolveDigitalPin(block);
        const state = block.getFieldValue('STATE') as 'ON' | 'OFF';

        registerSetupCode(pin, `  pinMode(${pin}, OUTPUT);\n  digitalWrite(${pin}, HIGH);\n`);

        const digitalValue = state === 'ON' ? 'LOW' : 'HIGH';
        return stmt(`digitalWrite(${pin}, ${digitalValue})`);
    };
}
